import { FaLocationDot } from "react-icons/fa6";
import { useCampuses } from "../../contexts/CampusContext";

const CampusesSection = () => {
  const {campuses} = useCampuses();

    // Add a safeguard for initial render
    if (!campuses) return <div>Loading campuses...</div>;


  return (
    <div className="w-full bg-white rounded-lg shadow-lg p-4 mt-4">
      <h2 className="text-xl font-bold text-dark mb-1">Campuses</h2>
      <p className="text-sm text-primary font-bold mb-4">Get to know our campuses near you</p>
      <ul className="w-full">
        {
          campuses.map((campus) => (
            <li className="w-full py-3 ps-1 hover:bg-gray-100 transition-colors rounded-md">
          <a
            href={campus.locationUrl}
            target="_blank"
            rel="noreferrer noopener"
            className="block "
          >
            <div className="font-bold text-dark">{campus.name}</div>
            <div className="flex items-center text-sm text-primary font-bold mt-1">
              <FaLocationDot className="mr-1" />
              <span>{campus.address}</span>
            </div>
          </a>
        </li>
          ))
        }
      </ul>
    </div>
  );
};

export default CampusesSection;